module.exports = __webpack_public_path__ + "recyclass.png?b916498f58ca90b566a9caa21fda3e31";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recyclass.png
// module id = 38
// module chunks = 0